module.exports = __webpack_public_path__ + "static/media/3 04 Tulleord Modil er feil-norming.deb69b5e.mp3";